import * as Tutorial from '.';
import * as Inventory from '../inventory';
import { TutorialStep } from './tutorial.ruleset';
import { action } from '@play-co/replicant';
import createActions from '../config/actions/createActions';

export const tutorialActions = createActions({
  completeTutorialStep: action((state, step: TutorialStep, api) => {
    if (Tutorial.getters.isTutorialStepComplete(state, step)) {
      throw new Error(`Tutorial step already complete: ${step}`);
    }

    Tutorial.modifiers.setTutorialStepComplete(state, step);

    const reward = Tutorial.getters.getTutorialReward(state, step);
    if (!reward) {
      return;
    }

    Inventory.modifiers.addPoints(
      state,
      reward,
      {
        feature: 'tutorial_reward',
        $subFeature: step,
      },
      api,
    );
  }),

  forceCompleteTutorialStep: action((state, step: TutorialStep, api) => {
    if (Tutorial.getters.isTutorialStepComplete(state, step)) {
      throw new Error(`Tutorial step already complete: ${step}`);
    }

    Tutorial.modifiers.setTutorialStepComplete(state, step);
  }),
});
